import { useEffect, useState } from "react";
import useHttp from "app/c1hooks/http";
import cacheDataService from "app/services/cacheDataService";
import _ from "lodash";

export function useFetchDropdownData(url, key, id, desc, isCache = true, isServer = false, extra) {

    const [dataList, setDataList] = useState([]);
    const { isLoading, res, error, sendRequest } = useHttp();

    useEffect(() => {
        //returning empty params
        if (!url) return;
        if (!id) return;
        if (!desc) return;

        if (key && isCache) {
            let cachedData = cacheDataService.getItemData(key);
            if (cachedData) {
                let dataArr = [];
                for (let i = 0; i < cachedData.length; i++) {
                    let jsonObj = cachedData[i];
                    if (id.indexOf('.') !== -1 || desc.indexOf('.') !== -1) {
                        dataArr.push({
                            value: getValue(jsonObj, id),
                            desc: getValue(jsonObj, desc)
                        });
                    } else {
                        if (jsonObj[id] && jsonObj[desc]) {
                            dataArr.push({
                                value: jsonObj[id],
                                desc: jsonObj[desc]
                            });
                        } else {
                            //use value / desc
                            dataArr.push({
                                value: jsonObj['value'],
                                desc: jsonObj['desc']
                            });
                        }

                    }
                }

                return setDataList(dataArr);
            }
        }

        if (isServer) {
            // console.log("Retrieving from API since nothing from cache.", url);
            if (url)
                sendRequest(url, 'get');
            else {
                setDataList([]);
            }

        }

    }, [url, key, id, desc, sendRequest, isCache, isServer]);

    useEffect(() => {
        if (!id) return;
        if (!desc) return;

        if (!isLoading && res) {
            let dataArr = [];
            //did a checking below as some API returns aaData instead of data directly
            let objArr = res.data && res.data.aaData ? res.data.aaData : res.data;
            for (let i = 0; i < objArr.length; i++) {
                let jsonObj = objArr[i];

                //if id has .
                if (id.indexOf('.') !== -1 || desc.indexOf('.') !== -1) {
                    if(extra?.length > 0){
                        const dataObj = {
                            value: getValue(jsonObj, id),
                            desc: getValue(jsonObj, desc)
                        }
                        extra.map((objKey) => {
                            dataObj[objKey] = getValue(jsonObj, objKey)
                        })
                        dataArr.push(dataObj);
                    }else {
                        dataArr.push({
                            value: getValue(jsonObj, id),
                            desc: getValue(jsonObj, desc)
                        });
                    }
                } else {
                    if(extra?.length > 0){
                        const dataObj = {
                            value: jsonObj[id],
                            desc: jsonObj[desc]
                        }
                        extra.map((objKey) => {
                            dataObj[objKey] = jsonObj[objKey]
                        })
                        dataArr.push(dataObj);
                    }else {
                        dataArr.push({
                            value: jsonObj[id],
                            desc: jsonObj[desc]
                        });
                    }
                }
            }

            if (isCache) {
                cacheDataService.setItem(key, dataArr)
            }

            setDataList(_.uniqBy(dataArr, "value"));
        }
        // eslint-disable-next-line
    }, [res, isLoading, error])

    if (!url)
        return [];
    return dataList;
}

function getValue(obj, selector) {
    if (selector.indexOf('.') !== -1) {
        let sel = selector.split('.');
        let val = getValueHelper(obj, sel);

        return val;
    }
    return obj[selector];
}

function getValueHelper(obj, fieldSelector) {
    if (fieldSelector.length > 1) {
        let field = fieldSelector.shift();
        let subObj;

        try {
            subObj = getValueHelper(obj[field], fieldSelector);
        } catch {
            subObj = getValueHelper(obj[field], fieldSelector);
        }

        return subObj;
    } else {
        return obj[fieldSelector.shift()];
    }
}









